<template>
  <div>
    <van-icon
      @click="$router.push('/')"
      class="icon"
      size="25"
      color="rgba(255,255,255,0.6)"
      name="arrow-left"
    />
    <van-tabs v-model="active" :swipeable="true" :sticky="true" line-height="0" @change="tabsChange">
      <van-tab v-for="(item, index) in tabsArr" :key="index">
        <template #title>
          <span
            :class="['tab-title', active == index ? 'tab-title-active' : '']"
          >
            {{ item }}
          </span>
        </template>
        <div class="content-box" v-if="active === 0">
          <div class="side-bar">
            <p
              :class="[
                'side-bar-item',
                bjParams.subjects.levelOne === sideItem.id ? 'side-bar-active' : '',
              ]"
              v-for="sideItem in classOneList"
              :key="sideItem.id"
              @click="sideBjBarChange(sideItem.id)"
            >
              {{ sideItem.subjectName }}
            </p>
          </div>
          <div class="content-list">
            <van-list
              offset="10"
              :immediate-check="false"
              v-model="loading"
              :finished="finished"
              :error="error"
              error-text="请求失败，点击重新加载"
              finished-text="没有更多了"
              @load="onLoad"
            >
              <van-cell
                class="list-item"
                v-for="bjItem in bjList"
                :key="bjItem.userId"
                @click="toDetail(0, bjItem.userId)"
              >
                <div class="item-card">
                  <div class="head-photo">
                    <img
                      v-if="bjItem.headPhoto"
                      :src="$global.imgUrl + bjItem.headPhoto"
                      alt=""
                    />
                    <Big
                      v-else
                      width="50"
                      height="50"
                      size="20"
                      :big="bjItem.realName"
                    />
                  </div>
                  <div class="content">
                    <p class="name">{{ bjItem.realName }}</p>
                    <p class="unit">{{ bjItem.unit }}</p>
                    <p class="subject">
                      <span
                        v-for="(subItem, subIndex) in bjItem.subjectList"
                        :key="subItem.id"
                        >{{ subItem.levelTwoName
                        }}{{
                          subIndex !== bjItem.subjectList.length - 1 ? "，" : ""
                        }}</span
                      >
                    </p>
                  </div>
                </div>
              </van-cell>
            </van-list>
          </div>
        </div>
        <div class="content-box" v-if="active === 1">
          <div class="side-bar">
            <p
              :class="[
                'side-bar-item',
                bkParams.levelOneCodes[0] === sideItem.code ? 'side-bar-active' : '',
              ]"
              v-for="sideItem in classOneList"
              :key="sideItem.id"
              @click="sideBkBarChange(sideItem.code)"
            >
              {{ sideItem.name }}
            </p>
          </div>
          <div class="content-list">
            <van-list
              offset="10"
              :immediate-check="false"
              v-model="loading"
              :finished="finished"
              :error="error"
              error-text="请求失败，点击重新加载"
              finished-text="没有更多了"
              @load="onBkLoad"
            >
              <van-cell
                class="list-item"
                v-for="bjItem in bkList"
                :key="bjItem.id"
                @click="toDetail(1, bjItem.id)"
              >
                <div class="item-card">
                  <div class="head-photo">
                    <img
                      v-if="bjItem.periodicalLogo"
                      :src="$global.imgUrl + bjItem.periodicalLogo"
                      alt=""
                    />
                    <Big
                      v-else
                      width="50"
                      height="50"
                      size="20"
                      :big="bjItem.name"
                    />
                  </div>
                  <div class="content">
                    <p class="bk-name">{{ bjItem.name }}</p>
                    <p class="core-name">{{ bjItem.coreName }}</p>
                    <p class="subject">
                      <span
                        v-for="(subItem, subIndex) in bjItem.organizerList"
                        :key="subItem.orgId"
                        >{{ subItem.orgName
                        }}{{
                          subIndex !== bjItem.organizerList.length - 1 ? "，" : ""
                        }}</span
                      >
                    </p>
                  </div>
                </div>
              </van-cell>
            </van-list>
          </div>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import { Icon } from "vant";
export default {
  components: {
    "van-icon": Icon,
  },
  data() {
    return {
      loading: false,
      finished: false,
      error: false,
      active: 0,
      tabsArr: ["百家号", "百科号"],
      classOneList: [],
      bjParams: {
        pageNo: 1,
        pageSize: 12,
        subjects: {
          levelOne: '',
        }
      },
      bjList: [],
      bkParams: {
        pageNo: 1,
        pageSize: 12,
        levelOneCodes: []
      },
      bkList: [],
    };
  },
  created() {
    this.getBjSideList();
  },
  methods: {
    // 百家滚动加载
    onLoad() {
      this.loading = true
      this.bjParams.pageNo += 1
      this.getBJList()
    },
    // 百家侧边栏点击
    sideBjBarChange(id) {
      this.loading = true
      this.bjParams.subjects.levelOne = id;
      this.bjParams.pageNo = 1
      this.bjList = []
      this.getBJList();
    },
    // 百家列表
    async getBJList() {
      const res = await this.$apis.hundredServe.getFamilyList(this.bjParams);
      if (res.resultCode === "200") {
        this.bjList.push(...res.data.list);
        this.finished = !res.data.hasNextPage
      } else {
        this.error = true
      }
      this.loading = false
    },
    // 百家分类
    async getBjSideList() {
      const resp = await this.$apis.hundredServe.getOneList();
      this.classOneList = resp.researchOneList;
      this.sideBjBarChange(this.classOneList[0].id);
    },
    
    
    // 百家滚动加载
    onBkLoad() {
      this.loading = true
      this.bkParams.pageNo += 1
      this.getBkList()
    },
    // 百科侧边栏点击
    sideBkBarChange(id) {
      this.loading = true
      this.bkParams.levelOneCodes = [id];
      this.bkParams.pageNo = 1
      this.bkList = []
      this.getBkList();
    },
    // 百科列表
    async getBkList() {
      const res = await this.$apis.hundredServe.getSectionList(this.bkParams);
      this.bkList.push(...res.periodicalList.list);
      this.finished = !res.periodicalList.hasNextPage
      this.loading = false
    },
    // 百科分类
    async getBkSideList() {
      const resp = await this.$apis.hundredServe.getPerOneList();
      this.classOneList = resp.perClaOneList;
      this.sideBkBarChange(this.classOneList[0].code);
    },

    // nav变化
    tabsChange(query) {
      switch (query) {
        case 0:
          this.error = false
          this.getBjSideList();
          break;
        case 1:
          this.error = false
          this.getBkSideList();
          break;
      }
    },
    // 跳转详情
    toDetail(type,id) {
        switch (type) {
          case 0:
            this.$router.push({
              path:'/appusesbaijia',
              query:{
                item: type,
                id
              }
            })   
            break;
          case 1:
            this.$router.push({
              path: "/appusesbaike",
              query: {
                item: type,
                id
              },
            });  
            break;
        }
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .van-tabs__wrap {
  height: 90px;
  .van-tabs__nav {
    justify-content: center;
    background-image: linear-gradient(#433ac7, #1c72f3);
    .van-tab {
      flex: none;
      align-items: flex-end;
      margin: 0 20px;
      padding-bottom: 20px;
      width: 20%;
    }
  }
}
.tab-title {
  font-size: 16px;
  color: #ffffff;
}
.tab-title-active {
  font-size: 20px;
}
.icon {
  position: absolute;
  top: 44px;
  left: 20px;
  z-index: 6;
}
.content-box {
  display: flex;
  .side-bar {
    padding-top: 20px;
    padding-right: 5px;
    width: 44%;
    height: calc(100vh - 90px);
    overflow-y: auto;
    background-color: #e4ebff;
    .side-bar-item {
      position: relative;
      padding-left: 20%;
      width: 100%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      font-size: 14px;
      font-weight: 700;
      color: #303030;
      line-height: 50px;
    }
    .side-bar-active {
      color: #2453d2;
      &::before {
        content: "";
        display: block;
        position: absolute;
        top: 17px;
        left: 12%;
        width: 5px;
        height: 15px;
        background: #2453d2;
        border-radius: 2px;
      }
    }
  }
  .content-list {
    width: 66%;
    height: calc(100vh - 90px);
    overflow-y: auto;
    .list-item {
      padding: 0;
      background-color: #f7f7f7;
      width: 100%;
      height: 121px;
      .item-card {
        display: flex;
        padding: 25px 4% 10px;
        width: 100%;
        height: 115px;
        background-color: #fff;
        .head-photo {
          margin-right: 10px;
          width: 50px;
          height: 50px;
          img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
          }
        }
        .content {
          width: calc(100% - 60px);
          .name {
            margin-bottom: 14px;
            width: 100%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 14px;
            font-weight: 700;
            color: #333333;
          }
          .bk-name {
            margin-bottom: 10px;
            width: 100%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 14px;
            font-weight: 700;
            color: #333333;
          }
          .unit,
          .subject {
            margin-bottom: 10px;
            width: 100%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 12px;
            color: #999999;
            line-height: 14px;
          }
          .core-name {
            margin-bottom: 10px;
            width: 100%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            line-height: 14px;
            font-size: 12px;
            color: #4266F5;
          }
        }
      }
    }
  }
}
</style>